import { gql } from '@apollo/client';

export function listQuery() {
  return gql`
    query LIST_POLICIES(
      $currentPage: Int!
      $currentPageSize: Int!
      $agencyId: [String]
      $product: [String]
      $effectiveDateFrom: Date
      $effectiveDateTo: Date
      $issueDateFrom: Date
      $issueDateTo: Date
      $Attribute: String!
      $Descending: Boolean!
      $keywordSearch: String
      $agentType: Insurance_AgentTypes
    ) {
      Insurance {
        queries {
          listDetailsPolicy(
            pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
            AgencyID: $agencyId
            Products: $product
            EffectiveDateFrom: $effectiveDateFrom
            EffectiveDateTo: $effectiveDateTo
            IssueFrom: $issueDateFrom
            IssueTo: $issueDateTo
            OrderBy: { Attribute: $Attribute, Descending: $Descending }
            KeywordSearch: $keywordSearch
            AgentType: $agentType
          ) {
            paging {
              pageSize
              pageSize
              totalCount
            }
            items {
              insurance_Policy_Id
              insuranceCustomer_FullName
              insurance_Policy_FullPolicyNumber
              insurance_Policy_LineOfBusiness {
                Code
                Title
              }
              insurancePolicyMotorDetails_Product {
                Code
                Title
              }
              insuranceAgency_AgencyName
              insurance_Policy_AssignedAgencyID {
                id
                views {
                  Insurance_all {
                    properties {
                      Id
                      AgencyName
                    }
                  }
                }
              }
              insuranceAgent_FirstName
              insuranceAgent_LastName
              insurance_Policy_AssignedAgentID {
                id
                views {
                  Insurance_all {
                    properties {
                      FirstName
                      LastName
                    }
                  }
                }
              }
              insurance_Policy_TotalAnnualPremium
              insurance_Policy_PolicyStatus {
                Code
                Title
              }
              insurance_Policy_PolicyEffectiveDate
              insurance_Policy_PolicyExpiryDate
              insurance_Policy_createdOn
              insurance_Policy_modifiedOn
              insuranceCustomer_FullName
              insurance_Policy_PolicyIssueDate
              insurance_Policy_FullName
            }
          }
        }
      }
    }
  `;
}

export function filterLovsQuery() {
  return gql`
    query POLICY_LISTING_LOVS {
      Insurance {
        queries {
          allAgencies {
            insurance_Agency_Id
            insurance_Agency_AgencyName
          }
        }
        lookups {
          products(Insurance_LinesOfBusiness: "Motor") {
            Id
            Code
            Title
          }
        }
      }
    }
  `;
}

export function exportMotorPolicies() {
  return gql`
    query exportMotorPolicies(
      $agencyId: [String]
      $effectiveDateFrom: Date
      $effectiveDateTo: Date
      $issueFrom: Date
      $issueTo: Date
      $products: [String]
      $lineOfBusiness: String!
      $agentType: Insurance_AgentTypes
    ) {
      Insurance {
        queries {
          ExportPolicies(
            AgencyID: $agencyId
            EffectiveDateFrom: $effectiveDateFrom
            EffectiveDateTo: $effectiveDateTo
            IssueFrom: $issueFrom
            IssueTo: $issueTo
            Products: $products
            LineOfBusiness: $lineOfBusiness
            AgentType: $agentType
          ) {
            insurance_Policy_FullPolicyNumber
            insurance_Policy_modifiedOn
            insurancePolicyMotorDetails_Id
            insurance_Policy_AgencyCommission
            insurancePolicyMotorDetails_Vignette
            insurancePolicyMotorDetails_VignetteCode
            insurance_Policy_IsRenewal
            insurance_Policy_RenewalNumber
            insurancePolicyMotorDetails_Motor
            insuranceAgent_CanViewCommission
            insurancePolicyMotorDetails_Product {
              Title
            }
            insurancePolicyMotorDetails_UsageType {
              Title
            }
            insurancePolicyMotorDetails_BodyType {
              Title
            }
            insurancePolicyMotorDetails_EngineType {
              Title
            }
            insurancePolicyMotorDetails_Brand {
              Title
            }
            insurancePolicyMotorDetails_Model {
              Title
            }
            insurancePolicyMotorDetails_YearOfMake
            insurancePolicyMotorDetails_PlateCode {
              Title
            }
            insurance_Policy_LineOfBusiness {
              Title
            }
            insurancePolicyMotorDetails_PlateNumber
            insurancePolicyMotorDetails_Weight
            insurancePolicyMotorDetails_EngineSize
            insurancePolicyMotorDetails_Seats
            insurancePolicyMotorDetails_Chassis
            insurancePolicyMotorDetails_HorsePower
            insuranceCustomer_FullName
            insuranceAgency_AgencyName
            insuranceAgent_FirstName
            insuranceAgent_LastName
            insurance_Policy_PolicyStatus {
              Title
            }
            insurance_Policy_ExternalReferenceId
            insurance_Policy_PolicyEffectiveDate
            insurance_Policy_PolicyExpiryDate
            insurance_Policy_TotalAnnualPremium
            insurance_Policy_PolicyIssueDate
            insurance_Policy_createdOn
            insuranceCustomer_Address {
              AddressDetails
              AddressDetailsArabic
              Building
              City
              Country {
                Code
                Id
                Title
              }
              Street
              Zone {
                Code
                Id
                Title
              }
            }
          }
        }
      }
    }
  `;
}

export function getMotorAgentInfo() {
  return gql`
    query getMotorAgentInfo($id: String!) {
      Insurance {
        entities {
          agent(id: $id) {
            views {
              Insurance_all {
                properties {
                  CanViewCommission
                }
              }
            }
          }
        }
      }
    }
  `;
}
